import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";

import { ItemsCarousel, SCarousel } from '../../styles/components/Carousel';

type CarrouselType = {
    items: {
        icon: ReactNode,
        title: string;
    }[]
}
const Carousel = ({ items }: CarrouselType) => {
    const [width, setWidth] = useState(0);
    const carousel = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        carousel.current
            && setWidth(carousel.current?.scrollWidth - carousel.current?.offsetWidth);
    }, [])
    return (

        <SCarousel
            ref={carousel}
            whileTap={{ cursor: "grabbing" }}
            maxlenght={items.length}
        >
            <motion.div
                drag="x"
                dragConstraints={{ right: 0, left: -width }}
            >
                {items.map((data, index) => (
                    <ItemsCarousel key={index}>
                        {data.icon}
                        <h3>{data.title}</h3>
                    </ItemsCarousel>
                ))}
            </motion.div>
        </SCarousel>
    )

};

export default Carousel;